import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";
import ItemService from "../../../../services/customer_appCommonService";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
//import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
// import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import toast from "react-hot-toast";
import { getTodaysData } from "../../../../common/Validations";
import CustomerConstants from "../../../../common/CustomerConstants";
import { useNavigate } from "react-router-dom";
import { getQtnJobList } from "../../../../redux/feature/customer_app/customerV1Slice";
import { useDispatch, useSelector } from "react-redux";
// import FileViewerModalNew from "../../../../Components/FileViewer/FileViewerModalForHB";
// import FileUploadComponentNew from "../../../../Components/formElements/FileUploadComponentNew";
import FileViewerModalForHB from "../../../../Components/FileViewer/FileViewerModalForHB";
import FileUploadComponentForHB from "../../../../Components/formElements/FileUploadComponentForHB";
// import useConfirmNavigation  from "../Estimation/useConfirmNavigation"
const EntryUpdate = React.forwardRef((props, ref) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // useConfirmNavigation();
  const [disabled, setDisabled] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const failureCashRequest = {
    title: "Warning",
    ErrorMsg: "",
  };

  const [getFailureCashRequest] = useState(failureCashRequest);
  const [getShowFailureModal, setShowFailureCashRequest] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checkerNameOptions, setCheckerNameOptions] = useState([]);

  let documentNumber = useSelector(
    (state) => state?.customerV1?.quotation_Job?.quotation_JobNr
  );

  const [formInputs, setFormInputs] = useState({});

// eslint-disable-next-line
  const [fileDeleted, setFileDeleted] = useState(false);

  const handleAttachmentDeleted = ({ attachmentId, hasFiles }) => {
    // If no files remain in the modal, we must clear the field in formInputs
    if (!hasFiles) {
      setFormInputs((prev) => ({
        ...prev,
        supportingDoc: "", // Clear the ID so the icon disappears
      }));

      // Optional: If you use the separate 'fileDeleted' state for other logic
      setFileDeleted(true);
    }
  };

  // Inside EntryUpdate component

  // const handleDeleteDocument = () => {
  //   // Clear the supportingDoc value to allow new upload
  //   setFormInputs((prev) => ({
  //     ...prev,
  //     supportingDoc: "", // Resetting this brings back the upload component
  //   }));
  // };

  useEffect(() => {
    if (!getDropdownData) return;
    setFormInputs((prev) => ({
      ...prev,
      [getDropdownData?.textField]: getDropdownData?.name,
      [getDropdownData?.textCode]: getDropdownData?.textCode,
      [getDropdownData?.textDesc]: getDropdownData?.textDesc,
    }));
    if (getDropdownData?.textField === "typeS") {
      setFormInputs((prev) => ({
        ...prev,
        typeS: getDropdownData?.name,
      }));
      if (getDropdownData.textField === "checkerName") {
        setFormInputs((prev) => ({
          ...prev,
          checkerName: getDropdownData.name,
          checkerNameCode: getDropdownData.textCode,
          checkerNameDesc: getDropdownData.textDesc,
        }));
      }
    }
  }, [getDropdownData]);

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const initialState = {
    transactionDate: getTodaysData() || "",
    clientName: "",
    companyName: "",
    location: "",
    validUntil: "",
    tenestinationDate: getTodaysData() || "",
    qtn_Job_RefNr: "",
    salesOfficerName: "",
    headerStatus: "",
    transactionCodeType: "",
    qtn_Job_Remarks: "",
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onSuccessUploadDocumentType = (data) => {
    const value = data.attachmentId || data.id;
    setFormInputs((prev) => ({
      ...prev,
      [data.fieldName]: value,
    }));
  };

  // const onSuccessUploadDocumentType = (data) => {
  //   setFormInputs((formInputs) => ({
  //     ...formInputs,
  //     [data.fieldName]: data.attachmentId,
  //   }));
  // };

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  //handle cancel modal
  const handleCancel = () => {
    setFormInputs((prev) => ({ ...prev, ...initialState }));
    props.onHide();
  };

  const handleInputChanges = (e) => {
    const { name, value } = e.target;
    setFormInputs((prev) => ({
      ...prev,
      [name]: value, // convert to uppercase here
    }));
  };

   const handleUppercaseBlur = (e) => {
  const { name, value } = e.target;

  if (!value) return;

  setFormInputs((prev) => ({
    ...prev,
    [name]: value.toUpperCase(),
  }));
};

  // Load Checker names
  const loadCheckerNames = async () => {
    try {
      const payload = { queryName: "Get_EMPLOYEE_LIST", category: "DESIGN" };
      const response = await ItemService.generateCustomerQuery(payload);
      if (response?.status === 200) {
        const mappedData = response.data.map((emp) => ({
          checkerNameCode: emp.userId,
          name: emp.firstName,
          textDesc: emp.lastName || "",
        }));
        setCheckerNameOptions(mappedData);

        // Set default if nothing selected
        if (!formInputs.checkerNameCode && mappedData.length > 0) {
          setFormInputs((prev) => ({
            ...prev,
            checkerName: mappedData[0].name,
            checkerNameCode: mappedData[0].checkerNameCode,
            checkerNameDesc: mappedData[0].textDesc,
          }));
        }
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
    loadCheckerNames();
    // eslint-disable-next-line
  }, []);
  const [queryName, setQueryName] = useState("");
  const loadFirstLevelData = async (queryName) => {
    if (!documentNumber) return;
    setLoading(true);

    let obj = {
      queryName: queryName,
      documentNumber: documentNumber,
    };

    try {
      const item = await ItemService.generateCustomerQuery(obj);

      if (item?.status === 200) {
        setFormInputs(item?.data[0]);
      } else {
        setFormInputs([]);
        console.log(`>> Error: Loading ${queryName}`);
      }
    } catch (error) {
      console.error(`>> API Error: ${queryName}`, error);
    }
    setLoading(false);
  };

  const queryMap = {
    J: "Get_JOB_DETAIL",
    QU: "Get_QUOTATION_DETAIL",
  };
  useEffect(() => {
    if (documentNumber) {
      if (documentNumber.startsWith("J")) {
        setQueryName(queryMap["J"]);
      } else if (documentNumber.startsWith("QU")) {
        setQueryName(queryMap["QU"]);
      }
    }
    // eslint-disable-next-line
  }, [documentNumber]);

  useEffect(() => {
    if (queryName && documentNumber) {
      loadFirstLevelData(queryName);
    }
    // eslint-disable-next-line
  }, [queryName, documentNumber]);

  const handleUpdate = async () => {
    let obj = {
      ...formInputs,
    };
    setDisabled(true);

    try {
      const item = await ItemService.updateQuotationOrJob(obj);
      if (item?.status === 200) {
        toast.success(item?.message || "Updated successfully", {
          duration: 2000,
          position: "top-right",
        });
        setFormInputs(
          item?.data?.length ? item.data : { ...formInputs, ...obj }
        );

        props.onHide();
        await dispatch(
          getQtnJobList({
            queryName: "Get_ENQUIRY_LIST",
            module: "",
            page: 1,
            per_page: 10,
          })
        );
        navigate(CustomerConstants.CUSTOMER_V4_HB_ENTRY_LIST);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error("Something went wrong. Please try again!", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      setDisabled(false);
    }
  };

  const hideFailureModal = () => {
    setShowFailureCashRequest(false);
  };

  const userData = JSON.parse(localStorage.getItem("userData"));
  // eslint-disable-next-line
  const hasDesignManager = userData?.data?.roles?.some(
    (r) => r.roleId === "DESIGN-MANAGER",
  );

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Project Details Update
          <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
            {documentNumber}
          </span>{" "}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/*03 */}
        {loading ? (
          <div className="flex justify-center items-center h-40">
            <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-green-500 border-solid"></div>
          </div>
        ) : (
          <div className="accordion mb-4" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                    <span className="iconLogo">BI</span>
                  </Col>

                  <Col xs={4} md={4} lg={4}>
                    <span className="headerTitle">Basic Information</span>
                    {/* <span className="subHeaderTitle">Inquire Details</span> */}
                  </Col>
                </Row>
              </h2>

              <div>
                <div className="accordion-body">
                  <Row>
                    <Col xs={12} md={12} lg={12}>
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              type="date"
                              label="Date"
                              name="transactionDate"
                              id="transactionDate"
                              value={formInputs?.transactionDate}
                              onChange={handleInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox uppercase-input"
                              label="Client Name "
                              name="clientName"
                              id="clientName"
                              value={formInputs?.clientName}
                              onBlur={handleUppercaseBlur}
                              onChange={handleInputChanges}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox uppercase-input"
                              label="Company Name"
                              name="companyName"
                              id="companyName"
                              value={formInputs?.companyName}
                              onBlur={handleUppercaseBlur}
                              onChange={handleInputChanges}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox uppercase-input"
                              label="Building name"
                              name="buildingName"
                              id="buildingName"
                              value={formInputs?.buildingName}
                              onBlur={handleUppercaseBlur}
                              onChange={handleInputChanges}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <TextAreaField
                              className="inputBox uppercase-input"
                              label="Location"
                              placeholder=""
                              name="location"
                              id="location"
                              value={formInputs?.location}
                              onBlur={handleUppercaseBlur}
                              onChange={handleInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox uppercase-input"
                              label="Sales Officer Name"
                              name="salesOfficerName"
                              id="salesOfficerName"
                              value={formInputs?.salesOfficerName}
                              onBlur={handleUppercaseBlur}
                              onChange={handleInputChanges}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Type"
                              name="type"
                              id="type"
                              value={formInputs?.type}
                              // onChange={handleInputChanges}
                              disabled={true}
                            />
                          </Col>
                          {formInputs?.type === "Job" && (
                            <>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Job Reference Number"
                                  name="jobReferenceNr"
                                  id="jobReferenceNr"
                                  value={formInputs?.jobReferenceNr}
                                  onChange={handleInputChange}
                                  disabled={!hasDesignManager}
                                />
                              </Col>
                            </>
                          )}
                          {formInputs?.type === "Quotation" && (
                            <>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Quotation Reference Number"
                                  name="qtnReferenceNr"
                                  id="qtnReferenceNr"
                                  value={formInputs?.qtnReferenceNr}
                                  onChange={handleInputChange}
                                  disabled={!hasDesignManager}
                                />
                              </Col>
                            </>
                          )}
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Revision"
                              name="revision"
                              id="revision"
                              value={formInputs?.version}
                              onChange={handleInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              type="date"
                              label="Estimation Date"
                              name="estimationDate"
                              id="estimationDate"
                              value={formInputs?.estimationDate}
                              onChange={handleInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox uppercase-input"
                              label="Designer"
                              name="designerName"
                              id="designerName"
                              value={formInputs?.designerName}
                              onBlur={handleUppercaseBlur}
                              onChange={handleInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              label="CheckerName"
                              placeholder=""
                              data={checkerNameOptions}
                              id="checkerName"
                              iconClassName="dropdownIcon"
                              name="checkerName"
                              code="checkerNameCode"
                              description="checkerNameDesc"
                              setValue={formInputs?.checkerName}
                              getvalue={setDropdownData}
                              required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <TextAreaField
                              className="inputBox uppercase-input"
                              label="Remarks"
                              placeholder=""
                              name="remarks"
                              id="remarks"
                              value={formInputs?.remarks}
                              onBlur={handleUppercaseBlur}
                              onChange={handleInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <FileUploadComponentForHB
                              id="supportingDoc"
                              name="supportingDoc"
                              label="Supporting Document"
                              allowedTypes={[
                                "image/png",
                                "image/jpeg",
                                "application/pdf",
                              ]}
                              multiple={false} // Change to false for single file selection
                              required={true}
                              onSuccessUpload={onSuccessUploadDocumentType}
                              value={formInputs?.supportingDoc || ""}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            {(formInputs?.supportingDoc && (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() =>
                                  handleViewFile(formInputs?.supportingDoc)
                                }
                              />
                            )) ||
                              "--"}
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
              {
                <Row className="my-4 ">
                  <Col
                    lg={{ span: 2, offset: 8 }}
                    className="d-flex justify-content-end mt-2"
                  >
                    <button
                      className="btnTable btn-danger"
                      onClick={handleCancel}
                      disabled={disabled}
                    >
                      Cancel
                    </button>
                  </Col>
                  <Col lg={2} className="d-flex justify-content-end mt-2">
                    <button
                      className="btnTable"
                      disabled={disabled}
                      onClick={handleUpdate}
                    >
                      Save
                    </button>
                  </Col>
                </Row>
              }
            </div>
          </div>
        )}
        <FailureModal
          show={getShowFailureModal}
          onHide={hideFailureModal}
          failureStockData={getFailureCashRequest}
        />
        {/* <FileViewerModal
          show={getShowFileViewModal}
          onHide={handleViewFileHide}
          fileid={getFileViewData}
        /> */}
        <FileViewerModalForHB
          show={getShowFileViewModal}
          onHide={handleViewFileHide}
          fileid={getFileViewData}
          onDeleteSuccess={handleAttachmentDeleted}
        />
      </Modal.Body>
    </Modal>
  );
});

export default EntryUpdate;
